import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavButtonsComponent } from '../nav_buttons.component';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { navBack, navSetActiveStep } from '../state/navigation_actions_creator';


@Component({
  selector: 'yi-finish-install',
  template: require('./last_step_nav.component.html'),
  styles: [require('../nav_buttons.components.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LastStepNavComponent extends NavButtonsComponent {

  backClickedOn() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Back'
    });
    if (this.currentStep.skipMainIntegrationPage) {
      this.store.dispatch(navSetActiveStep({activeStep: this.currentStep.prevStep}));
    } else {
      this.store.dispatch(navBack());
    }
  }

  finishInstallClicked() {
    this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.COMPLETED,
      isSkipped: 0,
      isWidgetV3: this.isWidgetV3,
      endScenario: REDCRSS_EVENTS.MANUAL_INSTALLATION
    });
    super.finishInstallClicked();
  }
}
